function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

export var getTotalCost = function getTotalCost(price, count, insurance) {
  if (count === void 0) {
    count = 1;
  }

  if (insurance === void 0) {
    insurance = 0;
  }

  return +(price * count + insurance * count).toFixed(2);
};
export var eventGoodsSetter = function eventGoodsSetter(eventGoodsObj, eGoods) {
  if (eGoods.length) {
    var _eGoods$, _extends2;

    var event = (_eGoods$ = eGoods[0]) == null ? void 0 : _eGoods$.event_public_id;

    var newObj = _extends(
      {},
      eventGoodsObj,
      ((_extends2 = {}), (_extends2[event] = eGoods), _extends2)
    );

    return newObj;
  } else {
    var _newObj = _extends({}, eventGoodsObj);

    return _newObj;
  }
}; // Формируем объект вида: { event: [...formats] } для проверки доступных билетов в корзине

export var ticketFormatsSetter = function ticketFormatsSetter(
  existingTicketFormats,
  newTicketFormats
) {
  if (newTicketFormats.length) {
    var _newTicketFormats$, _newTicketFormats$2, _extends3;

    var event =
      ((_newTicketFormats$ = newTicketFormats[0]) == null
        ? void 0
        : _newTicketFormats$.event_public_id) +
      "_" +
      ((_newTicketFormats$2 = newTicketFormats[0]) == null ? void 0 : _newTicketFormats$2.address);

    var newObj = _extends(
      {},
      existingTicketFormats,
      ((_extends3 = {}), (_extends3[event] = newTicketFormats), _extends3)
    );

    return newObj;
  } else {
    return _extends({}, existingTicketFormats);
  }
}; // VIP user discount price

export var setCostItem = function setCostItem(item, user) {
  var price = item.price,
    count = item.count;
  var discount = user.discount,
    discount_form = user.discount_form,
    role = user.role;
  var cost;

  if (role === "vip" && item.selector === "ticket") {
    var discountAmount = discount_form === "percent" && discount !== 100 ? discount / 100 : 0;
    var oneTicketVipPrice = price - price * 1 * discountAmount;
    var restTicketsPrice = count === 1 ? 0 : price * (count - 1);
    cost = oneTicketVipPrice + restTicketsPrice;
  } else {
    cost = price * count;
  }

  return cost;
}; // ф-ция счетчик для скидки - используется в useEffect, чтобы
// на момент рендера компонента считать скидку

export var saleCounter = function saleCounter(oneGoods, sale) {
  var discount = 0;

  if (sale.code_count >= oneGoods.count) {
    discount = oneGoods.price * oneGoods.count * (sale.discount / 100);
  } else {
    discount = oneGoods.price * sale.code_count * (sale.discount / 100);
  }

  return discount < 0 ? 0 : discount;
}; // Получить цену с учетом скидки

export var setDiscountPrice = function setDiscountPrice(price, discount, discount_form) {
  var discountPrice = 0;

  if (discount_form === "percent") {
    discountPrice = discount !== 100 ? price - price * 1 * (discount / 100) : 0;
  }

  return discountPrice;
};
